module.exports = __webpack_public_path__ + "images/0cc0565945d71fb20504dfef53831545.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/3.png
// module id = 379
// module chunks = 0